export default function CollectionFilter() {
  const selectors = {
    filterSelection: '#FilterTags',
    sortSelection: '#SortBy',
  };
  const filter = document.querySelector(selectors.filterSelection);
  const sort = document.querySelector(selectors.sortSelection);
  const defaultSortValue = sort.dataset.defaultSortby;

  function onFilterChange(event) {
    document.location.href = event.target.value;
  }

  function onSortChange(event) {
    window.location.search = decodeURIComponent(
      new URLSearchParams({ sort_by: event.target.value || defaultSortValue }).toString()
    );
  }

  function init() {
    if (filter) {
      filter.addEventListener('change', (event) => onFilterChange(event));
    }
    if (sort) {
      sort.addEventListener('change', (event) => onSortChange(event));
    }
  }

  if (document.body.classList.contains('page-type-collection')) {
    init();
  }
}
